import classes from "./style.module.scss";
import { getFileType } from '../../../../helpers';

const DisplayCard = (props) => {
  const { notoficationInfo } = props;

  const isPDF = (url) => {
    return url?.endsWith(".pdf");
  };

  const handleView = (imageUrl) => {
    window.open(imageUrl, "_blank");
  };

  return (
    <>
      <div className={`${classes.notifyCardWrapper} mb-4`}>
        <div className={`${classes.detailsWrapper}`}>
          <div className="flex items-center mb-3">
            <div
              className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}
            >
              Images
            </div>
          </div>
          <div className={`${classes.displayProductWrapper}`}>
            <div className={classes.productLogoWrap}>
              {notoficationInfo?.documents?.map((doc, index) => (
                <div
                  className={classes.productLogoWrap}
                  key={index}
                  onClick={() => handleView(doc)}
                >
                  <img src={doc} alt='image' className='w-[100%] h-[100%]' style={{ objectFit: 'contain' }} />
                  {/* {isPDF(doc) ? (
                    <img
                      src={pdfLogo}
                      alt="PDF Logo"
                      style={{ cursor: "pointer" }}
                    />
                  ) : (
                    <img
                      src={doc}
                      alt={`Document ${index + 1}`}
                      style={{ cursor: "pointer" }}
                    />
                  )} */}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisplayCard;
